export type ResolvedSidePanelCommandHandler<THandler> = {
    ownerId: string;
    handler: THandler;
};

export function resolveCommandHandler<THandler>(
    ownerChain: readonly string[],
    commandName: string,
    handlersByOwner: ReadonlyMap<string, ReadonlyMap<string, THandler>>
): ResolvedSidePanelCommandHandler<THandler> | undefined {
    for (const ownerId of ownerChain) {
        const handler = handlersByOwner.get(ownerId)?.get(commandName);
        if (handler !== undefined) {
            return { ownerId, handler };
        }
    }

    return undefined;
}
